export { SpacesSidebarVariant } from './SpacesSidebarVariant'
